import { Avatar, Box, Button, Flex } from "@chakra-ui/react";
import { User } from "../../../../../../definitions/interfaces/Users/Users.interface";
import {
  ReactDispatchUserState,
} from "../../../../../../definitions/interfaces/Global/ReactDispatchStringState.type";
import "../../styles/ItemManagerTeam.scss";
import BodyText from "../../../../../../components/Common/BodyText";
import { colors } from "../../../../../../definitions/constants/GlobalStyles";

const ItemInviteManager = ({
  item,
  setUser,
  userActive,
}: {
  item: User;
  setUser: ReactDispatchUserState;
  userActive: User;
}): JSX.Element => {
  return (
    <Button
      sx={{
        border:
          userActive?.id === item?.id
            ? `1px solid ${colors.figmaColors.secColor}`
            : null,
      }}
      className="container-item-user"
      justifyContent="flex-start"
      onClick={() => setUser(item)}
    >
      <Box className="user-detail">
        <Avatar
          src={item.image_url}
          name={`${item.firstname} ${item.lastname}`}
        />
        <Flex direction='column' alignItems="flex-start">
          <BodyText
            fontSize={{ base: "12px", md: "13px" }}
            fontWeight="bold"
            textColor={colors.text.black}
          >
            {item.firstname} {item.lastname}
          </BodyText>
          <BodyText
            fontSize={{ base: "12px", md: "13px" }}
            fontWeight="regular"
            textColor={colors.text.lightGray3}
          >
            {`@${item?.firstname?.toLowerCase()?.trim()}${item.lastname
              .toLowerCase()
              .trim()}`.trim()}
          </BodyText>
        </Flex>
      </Box>
    </Button>
  );
};
export default ItemInviteManager;
